import React, { useState, useEffect } from 'react';
import api from '../../api';
import './Admin.css';

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [actionLoading, setActionLoading] = useState(null); // Fix #17

  const load = () => api.get('/admin/users').then(r => { setUsers(r.data); setLoading(false); }).catch(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const doAction = async (id, action) => {
    setActionLoading(id + action);
    try { await action(); await load(); } catch(e) { alert(e.response?.data?.error || 'Error'); }
    setActionLoading(null);
  };

  const approve = (id) => doAction(id + 'approve', () => api.patch(`/admin/users/${id}/approve`));
  const reject  = (id) => { if(window.confirm('Reject this registration?')) doAction(id + 'reject', () => api.patch(`/admin/users/${id}/reject`)); };
  const revoke  = (id) => { if(window.confirm('Revoke buyer access?')) doAction(id + 'revoke', () => api.patch(`/admin/users/${id}/revoke`)); };
  const del     = (id) => { if(window.confirm('Permanently delete this user?')) doAction(id + 'delete', () => api.delete(`/admin/users/${id}`)); };

  const filtered = users.filter(u => filter === 'all' ? true : filter === 'pending' ? u.status === 'pending' : filter === 'buyers' ? u.role === 'buyer' : u.status === 'rejected');

  const statusBadge = (u) => {
    if (u.status === 'pending') return <span className="badge badge-warning">Pending</span>;
    if (u.status === 'rejected') return <span className="badge badge-error">Rejected</span>;
    if (u.role === 'buyer') return <span className="badge badge-success">Authorised Buyer</span>;
    return <span className="badge badge-gray">Standard Viewer</span>;
  };

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <h1 className="admin-page-title">Users</h1>
        <div style={{display:'flex',gap:'8px'}}>
          {['all','pending','buyers','rejected'].map(f => (
            <button key={f} onClick={() => setFilter(f)} className="admin-btn" style={{background: filter===f ? 'var(--charcoal)' : 'var(--cream-dark)', color: filter===f ? 'white' : 'var(--gray)'}}>
              {f.charAt(0).toUpperCase()+f.slice(1)}
            </button>
          ))}
        </div>
      </div>
      {loading ? <div className="page-loading"><div className="spinner" /></div> : (
        <table className="admin-table">
          <thead><tr>
            <th>Company</th><th>Name</th><th>Email</th><th>Phone</th><th>VAT</th><th>Status</th><th>Registered</th><th>Actions</th>
          </tr></thead>
          <tbody>
            {filtered.map(u => (
              <tr key={u._id}>
                <td><strong>{u.company_name}</strong></td>
                <td>{u.full_name}</td>
                <td>{u.email}</td>
                <td>{u.phone}</td>
                <td>{u.vat_number || '—'}</td>
                <td>{statusBadge(u)}</td>
                <td style={{fontSize:'12px',color:'var(--gray)'}}>{new Date(u.createdAt).toLocaleDateString('en-GB')}</td>
                <td>
                  <div className="admin-actions">
                    {u.status === 'pending' && <>
                      <button className="admin-btn admin-btn-approve" onClick={() => approve(u._id)} disabled={actionLoading}>
                        {actionLoading === u._id+'approve' ? '...' : 'Approve'}
                      </button>
                      <button className="admin-btn admin-btn-reject" onClick={() => reject(u._id)} disabled={actionLoading}>
                        {actionLoading === u._id+'reject' ? '...' : 'Reject'}
                      </button>
                    </>}
                    {u.role === 'buyer' && <button className="admin-btn admin-btn-reject" onClick={() => revoke(u._id)} disabled={actionLoading}>
                      {actionLoading === u._id+'revoke' ? '...' : 'Revoke'}
                    </button>}
                    {u.status === 'rejected' && <button className="admin-btn admin-btn-approve" onClick={() => approve(u._id)} disabled={actionLoading}>
                      {actionLoading === u._id+'approve' ? '...' : 'Re-approve'}
                    </button>}
                    <button className="admin-btn admin-btn-delete" onClick={() => del(u._id)} disabled={actionLoading}>
                      {actionLoading === u._id+'delete' ? '...' : 'Delete'}
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan="8" style={{textAlign:'center',padding:'32px',color:'var(--gray)'}}>No users found.</td></tr>}
          </tbody>
        </table>
      )}
    </div>
  );
}
